import { render, staticRenderFns } from "./faqData.vue?vue&type=template&id=5c724ce4&scoped=true"
import script from "./faqData.vue?vue&type=script&lang=js"
export * from "./faqData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c724ce4",
  null
  
)

export default component.exports